export default "__VITE_ASSET__2c03ebe6__"